import { ProviderPreferences, providerPreferences } from "app2/api";

import { useUserPreference } from 'app2/views/shared-public';

export function useProviderPreference<P extends keyof ProviderPreferences>(p:P) {
  return useUserPreference<ProviderPreferences, P>(providerPreferences, p);
}
